import { lt } from '@mews/framework';
import { Optional } from '@mews/std';
import { RadioButton, Typography } from '@optimus-web/core';
import { matchAndMergeTestIds } from '../../../../../../../constants';
import { CellLayout } from './CellLayout';

export interface GridHeaderProps
    extends Pick<SelectProfileCellProps, 'selectedProfileId' | 'mergeDisabled' | 'onSelectAll'> {
    leftProfileId: string;
    rightProfileId: string;
}

const label = (
    <Typography textStyle="bodyMediumStrong" as="div">
        {lt('SelectAll')}
    </Typography>
);

interface SelectProfileCellProps {
    mergeDisabled: boolean;
    profileId: string;
    selectedProfileId: Optional<string>;
    onSelectAll: (targetId: string) => void;
}

const SelectProfileCell = ({ mergeDisabled, profileId, selectedProfileId, onSelectAll }: SelectProfileCellProps) => (
    <CellLayout selected={selectedProfileId === profileId} headerElement>
        <RadioButton
            disabled={mergeDisabled}
            value={profileId}
            id={profileId}
            data-test-id={`${matchAndMergeTestIds.selectAllFields}-${profileId}`}
            onChange={() => onSelectAll(profileId)}
            checked={selectedProfileId === profileId}
            label={label}
        />
    </CellLayout>
);

export const GridHeader = ({ leftProfileId, rightProfileId, ...other }: GridHeaderProps) => (
    <>
        <CellLayout {...other} headerElement>
            <Typography textStyle="bodyMediumStrong" as="div">
                {lt('AccountMergeConflictingFieldsPropertiesHeader')}
            </Typography>
        </CellLayout>
        <SelectProfileCell {...other} profileId={leftProfileId} />
        <SelectProfileCell {...other} profileId={rightProfileId} />
    </>
);
